import script from "./MobileProfessionSituation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileProfessionSituation.vue?vue&type=script&lang=ts&setup=true"

import "./MobileProfessionSituation.vue?vue&type=style&index=0&id=80abf52a&scoped=true&lang=css"
import "./MobileProfessionSituation.vue?vue&type=style&index=1&id=80abf52a&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80abf52a"]])

export default __exports__